module.exports = __webpack_public_path__ + "img/barracks64_ua.f78e6af3.webp";